var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13055_141243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.36 16.3637C31.36 15.2291 31.2582 14.1382 31.0691 13.0909H16V19.2873H24.6109C24.2327 21.28 23.0982 22.9673 21.3964 24.1019V28.1309H26.5891C29.6145 25.3382 31.36 21.2364 31.36 16.3637Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C20.32 32 23.9418 30.5746 26.5891 28.1309L21.3964 24.1018C19.9709 25.0618 18.1527 25.6437 16 25.6437C11.84 25.6437 8.30546 22.8364 7.04001 19.0546H1.71637V23.1855C4.3491 28.4073 9.74546 32 16 32Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04 19.04C6.72 18.08 6.53091 17.0618 6.53091 16C6.53091 14.9382 6.72 13.92 7.04 12.96V8.8291H1.71636C0.625455 10.9818 0 13.4109 0 16C0 18.5891 0.625455 21.0182 1.71636 23.1709L5.86182 19.9418L7.04 19.04Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.37091C18.3564 6.37091 20.4509 7.18545 22.1236 8.75636L26.7055 4.17455C23.9273 1.58545 20.32 0 16 0C9.74546 0 4.3491 3.59273 1.71637 8.82909L7.04001 12.96C8.30546 9.17818 11.84 6.37091 16 6.37091Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13055_141243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_Icon.0773a8fe1c6e055d1a0d537a03a5eece.svg";
export { ForwardRef as ReactComponent };